/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ValidationType {
    EMAIL = 'Email',
    PHONE = 'Phone',
    URL = 'URL',
    SIN = 'SIN',
}
